export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fee3d0c0589923f505a3bdfadbff25923d0958a9f&name=fetchTypeahead!'